import UserInfo from "./user-info";

export default UserInfo;
